// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3TEyq","col":"CardReaderDesc_col__2m61Q","label":"CardReaderDesc_label__28gGB"};